module.exports = __webpack_public_path__ + "static/media/nacex.6aadafa5.svg";